module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00039.72328b01.png";